"use client";
import Box from "@mui/material/Box";
import { useSession } from "next-auth/react";
import AdminBlogPageStats from "./AdminBlogPageStats";

export default function AdminBlogSection({ slug }: { slug: string }) {
  const { data: session } = useSession();
  const isAdmin = session?.user?.role === "admin";

  if (!isAdmin) return null;

  return (
    <Box sx={{
      mt: 2, p: 2,
      border: "1px solid",
      borderLeftWidth: { xs: 0, sm: 1 },
      borderRightWidth: { xs: 0, sm: 1 },
      borderColor: "warning.main",
      bgcolor: "color-mix(in srgb, var(--mui-palette-warning-main), transparent 90%)",
    }}>
      <AdminBlogPageStats slug={slug} />
    </Box>
  );
}
